<div>
  <div class="modal-header">{{'dso-selector.'+ action + '.' + objectType.toString().toLowerCase() + '.head' | translate}}
    <button type="button" class="close" (click)="close()" aria-label="Close">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <span *ngIf="header" class="h5 px-2">{{header | translate}}</span>
    <ds-authorized-collection-selector [currentDSOId]="dsoRD?.payload.uuid"
                                       [entityType]="entityType"
                                       [types]="selectorTypes"
                                       [action]="rpActionType"
                                       (onSelect)="selectObject($event)"></ds-authorized-collection-selector>
  </div>
</div>
